const state = () => ({
  chirpIcon: null,
  chirpNotification: null,
  notificationChannels: [],
  notificationRules: [],
  toastNotifications: [],
});

export default state;
